<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>credit_card</md-icon>
          </div>
          <h4 class="title">VIP用户</h4>
        </md-card-header>
        <md-card-content>
          <div>
            <div class="md-layout">
              <div class="md-layout-item md-size-50 mx-auto text-center">
                <h3 class="title text-success">元学.MetaStation VIP用户</h3>
              </div>
            </div>
            <div
              class="
                md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100
              "
              style="padding-left: 0px; padding-right: 0px; margin-bottom: 25px;padding-top: 20px;"
            >
              <img src="/img/vipx.png" style="height: 245px; width: 100%" />
            </div>
            <div class="md-layout">
              <div class="md-layout-item md-size-70 mx-auto text-center">
                <div class="md-layout">
                  <div
                    class="
                      md-layout-item
                      md-medium-size-20
                      md-small-size-50
                      md-xsmall-size-100
                      md-size-20
                    "
                  >
                    <pricing-card icon-color="icon-danger">
                      <h6
                        slot="category"
                        class="category"
                        style="padding-top: 25px"
                      >
                        连续包月
                      </h6>
                      <img
                        slot="icon"
                        src="img/month_red.png"
                        style="height: 60px; width: 60px"
                      />
                      <h3 slot="title" class="title text-danger">¥ 60 / 月</h3>
                      <p slot="description" class="card-description">
                        首月优惠30元 ,
                        <span style="text-decoration: line-through"
                          >90元/月</span
                        >
                      </p>
                      <md-button slot="footer" class="md-danger md-round md-sm"
                        >选 择</md-button
                      >
                      <p slot="remark" class="card-remark">
                        会员到期前1天自动扣款续费90元,可随时取消,阅读
                        <a href="#">自动续费协议</a>
                      </p>
                    </pricing-card>
                  </div>
                  <div
                    class="
                      md-layout-item
                      md-medium-size-20
                      md-small-size-50
                      md-xsmall-size-100
                      md-size-20
                    "
                  >
                    <pricing-card
                      card-class="md-card-plain"
                      icon-color="icon-success"
                    >
                      <h6
                        slot="category"
                        class="category"
                        style="padding-top: 25px"
                      >
                        连续包季
                      </h6>
                      <img
                        slot="icon"
                        src="img/month_green.png"
                        style="height: 60px; width: 60px"
                      />
                      <h3 slot="title" class="title text-success">
                        ¥ 180 / 季
                      </h3>
                      <p slot="description" class="card-description">
                        首季优惠90元 ,
                        <span style="text-decoration: line-through"
                          >270元/季</span
                        >
                      </p>
                      <md-button slot="footer" class="md-success md-round md-sm"
                        >选 择</md-button
                      >
                      <p slot="remark" class="card-remark">
                        会员到期前1天自动扣款续费270元,可随时取消,阅读
                        <a href="#">自动续费协议</a>
                      </p>
                    </pricing-card>
                  </div>
                  <div
                    class="
                      md-layout-item
                      md-medium-size-20
                      md-small-size-50
                      md-xsmall-size-100
                      md-size-20
                    "
                  >
                    <pricing-card
                      card-class="md-card-plain"
                      icon-color="icon-success"
                    >
                      <h6
                        slot="category"
                        class="category"
                        style="padding-top: 25px"
                      >
                        连续包年
                      </h6>
                      <img
                        slot="icon"
                        src="img/year_green.png"
                        style="height: 60px; width: 60px"
                      />
                      <h3 slot="title" class="title text-success">
                        ¥ 810 / 年
                      </h3>
                      <p slot="description" class="card-description">
                        首年优惠270元 ,
                        <span style="text-decoration: line-through"
                          >1080元/年</span
                        >
                      </p>
                      <md-button slot="footer" class="md-success md-round md-sm"
                        >选 择</md-button
                      >
                      <p slot="remark" class="card-remark">
                        会员到期前1天自动扣款续费1080元,可随时取消,阅读
                        <a href="#">自动续费协议</a>
                      </p>
                    </pricing-card>
                  </div>
                  <div
                    class="
                      md-layout-item
                      md-medium-size-20
                      md-small-size-50
                      md-xsmall-size-100
                      md-size-20
                    "
                  >
                    <pricing-card
                      card-class="md-card-plain"
                      icon-color="icon-success"
                    >
                      <h6
                        slot="category"
                        class="category"
                        style="padding-top: 25px"
                      >
                        按月购买
                      </h6>
                      <img
                        slot="icon"
                        src="img/smonth_green.png"
                        style="height: 60px; width: 60px"
                      />
                      <h3 slot="title" class="title text-success">¥ 90 / 月</h3>
                      <p slot="description" class="card-description">
                        折扣根据选择期限制定
                      </p>
                      <drop-down direction="down" slot="footer">
                        <md-button
                          class="
                            md-button md-success md-round md-block md-sm
                            dropdown-toggle
                          "
                          data-toggle="dropdown"
                        >
                          选 择
                        </md-button>
                        <ul class="dropdown-menu dropdown-menu-right">
                          <li><a href="#">1个月</a></li>
                          <li><a href="#">2个月</a></li>
                          <li><a href="#">3个月</a></li>
                          <li><a href="#">4个月</a></li>
                          <li><a href="#">5个月</a></li>
                        </ul>
                      </drop-down>
                      <p slot="remark" class="card-remark">
                        5个月以上购买,请选择按年购买
                      </p>
                    </pricing-card>
                  </div>
                  <div
                    class="
                      md-layout-item
                      md-medium-size-20
                      md-small-size-50
                      md-xsmall-size-100
                      md-size-20
                    "
                  >
                    <pricing-card
                      card-class="md-card-plain"
                      icon-color="icon-success"
                    >
                      <h6
                        slot="category"
                        class="category"
                        style="padding-top: 25px"
                      >
                        按年购买
                      </h6>
                      <img
                        slot="icon"
                        src="img/syear_green.png"
                        style="height: 60px; width: 60px"
                      />
                      <h3 slot="title" class="title text-success">
                        ¥ 1080 / 年
                      </h3>
                      <p slot="description" class="card-description">
                        折扣根据选择期限制定
                      </p>
                      <drop-down direction="down" slot="footer">
                        <md-button
                          class="
                            md-button md-success md-round md-block md-sm
                            dropdown-toggle
                          "
                          data-toggle="dropdown"
                        >
                          选 择
                        </md-button>
                        <ul class="dropdown-menu dropdown-menu-right">
                          <li><a href="#">半 年</a></li>
                          <li><a href="#">1 年</a></li>
                          <li><a href="#">2 年</a></li>
                          <li><a href="#">3 年</a></li>
                          <li><a href="#">4 年</a></li>
                          <li><a href="#">5 年</a></li>
                          <li><a href="#">5年以上</a></li>
                        </ul>
                      </drop-down>
                      <p slot="remark" class="card-remark">
                        5年以上购买,请联系专属客服
                      </p>
                    </pricing-card>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <hr class="text-success" />
            <br />
            <div class="md-layout">
              <div class="md-layout-item md-size-70 mx-auto text-center">
                <div class="md-layout">
                  <div class="md-layout-item md-size-30 md-small-size-30">
                    <md-button class="md-gray" style="border: 1px"
                      ><img
                        src="img/alipay.png"
                        style="width: 16px; height: 16px"
                      />
                      &nbsp;&nbsp;<span class="text-info"
                        >支付宝支付</span
                      ></md-button
                    >
                  </div>
                  <div class="md-layout-item md-size-30 md-small-size-30">
                    <md-button class="md-gray" style="border: 1px"
                      ><img
                        src="img/wepay.png"
                        style="width: 16px; height: 16px"
                      />
                      &nbsp;&nbsp;<span class="text-success"
                        >微信支付</span
                      ></md-button
                    >
                  </div>
                  <div
                    class="md-layout-item md-size-40 md-small-size-40"
                    style="padding-top: 10px"
                  >
                    <span class="text-success"
                      ><a href="#">《元学.MetaStation服务协议》</a></span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import { PricingCard } from "@/components";
export default {
  components: {
    PricingCard,
  },
};
</script>
<style scoped>
.text-center {
  text-align: center;
}

.md-card-pricing ul li {
  padding: 0px;
  border: 0;
}
</style>